<div
   class="tab-item"
   [class.margin-right]="tabPosition === 'left'"
   [class.margin-bottom]="tabPosition === 'top'"
   [class.margin-left]="tabPosition === 'right'"
   [class.margin-top]="tabPosition === 'bottom'"
>
   <div
      [fxLayoutAlign]="tabPosition === 'left' || tabPosition === 'right' ? 'left center' : 'center center'"
      class="sam-padding"
      fxFill
      [style.border-color]="tab.tabColor"
      [class.border-left]="tabPosition === 'left'"
      [class.border-top]="tabPosition === 'top'"
      [class.border-right]="tabPosition === 'right'"
      [class.border-bottom]="tabPosition === 'bottom'"
   >
      <fa-icon
         class="sam-margin-right-medium"
         size="lg"
         *ngIf="(tabPresentationType$ | async)?.showIcon"
         [icon]="tab.tabIcon | iconNameToIconDefinition$ | async"
         [style.color]="tab.tabColor"
         [fixedWidth]="true"
      ></fa-icon>
      <ng-container *ngIf="(tabPresentationType$ | async)?.showText && tab.tabTitle">
         {{ tab.tabTitle }}
      </ng-container>

      <ng-container *ngIf="(tabPresentationType$ | async)?.showText && !tab.tabTitle">
         {{ tab.brickInstanceId | instanceIdToBrickTitle$ | async }}
      </ng-container>
   </div>
</div>
